import { useEffect, useState } from "react";
import MissionCard from "./Components/MissionCard";
import * as Ionicons from "react-icons/io";
import { useMutation, useQuery } from "@apollo/client";
import { Button, Card, Col, Row } from "reactstrap";
import {
  GET_ORG_PROFILE_2,
  QUERY_CSO_COLLABORATION_NEEDS,
  QUERY_CSO_COLLABORATION_NEEDS_FIELDS,
  QUERY_CSO_COLLABORATION_POLICY,
  QUERY_GET_ALL_ACTIVITY,
  QUERY_GET_ALL_COUNTRIES,
  QUERY_SUPPORTER_INFORMATION,
  UPDATE_CSO_COLLABORATION_NEEDS,
} from "../../../queries";
import { Multiselect } from "react-widgets";
import { useMyOrgInfo } from "../../../Layout/AppMain/LoginStatusContext";
import Loader from "react-loaders";

const SettingOrgTab2 = ({ obj, userId, loading }) => {
  const myOrgInfo = useMyOrgInfo();
  const [editState, setEditState] = useState(false);
  const [interestingCounries, setInterestingCounries] = useState([]);
  const [selectedIssues, setSelectedIssues] = useState([]);
  const [
    selectedCorporationCategoryNeeds,
    setSelectedCorporationCategoryNeeds,
  ] = useState([]);
  const [selectedStakeholder, setSelectedStakeholder] = useState([]);
  const myPage = myOrgInfo.id == obj.id;

  const collaborationNeeds = useQuery(QUERY_CSO_COLLABORATION_NEEDS);
  const csoCollaborationPolicy = useQuery(QUERY_CSO_COLLABORATION_POLICY);
  const allActivity = useQuery(QUERY_GET_ALL_ACTIVITY);
  const supporterInformation = useQuery(QUERY_SUPPORTER_INFORMATION);
  const foreignBranchCountries = useQuery(QUERY_GET_ALL_COUNTRIES);
  const allFields = useQuery(QUERY_CSO_COLLABORATION_NEEDS_FIELDS);

  const { refetch: refetchOrgInfo } = useQuery(GET_ORG_PROFILE_2, {
    variables: {
      id: obj.pk,
    },
  });
  const [updateCollaborationNeeds] = useMutation(
    UPDATE_CSO_COLLABORATION_NEEDS,
    {
      onCompleted: () => {
        setEditState(false);
        refetchOrgInfo();
        collaborationNeeds.refetch();
        csoCollaborationPolicy.refetch();
        allActivity.refetch();
        supporterInformation.refetch();
        foreignBranchCountries.refetch();
      },
    }
  );

  const SettingIcon = Ionicons["IoIosSettings"];
  const SyncIcon = Ionicons["IoIosSync"];
  const CloseIcon = Ionicons["IoMdClose"];

  function handleChangeIssue(issue) {
    const isAvailable = selectedIssues?.find(
      (x) => x.node.id === issue.node.id
    );
    if (!isAvailable) {
      setSelectedIssues((prev) => {
        console.log("prev", prev);
        return [...prev, issue];
      });
    } else {
      setSelectedIssues(() => {
        return selectedIssues.filter((x) => x.node.id !== issue.node.id);
      });
    }
  }

  function handleChangeNeed(need) {
    const isAvailable = selectedCorporationCategoryNeeds?.find(
      (x) => x.node.id === need.node.id
    );
    if (isAvailable === undefined) {
      setSelectedCorporationCategoryNeeds((prev) => {
        return [...prev, need];
      });
    } else {
      setSelectedCorporationCategoryNeeds(() => {
        return selectedCorporationCategoryNeeds.filter(
          (x) => x.node.id !== need.node.id
        );
      });
    }
  }

  function handleChangeStakeholder(stakeholder) {
    const isAvailable = selectedStakeholder?.find(
      (x) => x.node.id === stakeholder.node.id
    );
    if (isAvailable === undefined) {
      setSelectedStakeholder((prev) => {
        return [...prev, stakeholder];
      });
    } else {
      setSelectedStakeholder(() => {
        return selectedStakeholder.filter(
          (x) => x.node.id !== stakeholder.node.id
        );
      });
    }
  }

  useEffect(() => {
    setInterestingCounries(
      collaborationNeeds?.data?.myCso?.edges[0]?.node?.csocollaborationneeds?.countries?.edges?.map(
        (country) => {
          return {
            id: country?.node?.id,
            nameJp: country?.node?.nameJp,
          };
        }
      ) ?? []
    );
    setSelectedIssues(
      collaborationNeeds?.data?.myCso?.edges?.[0]?.node?.csocollaborationneeds
        ?.activityFields?.edges ?? []
    );
    setSelectedCorporationCategoryNeeds(
      collaborationNeeds?.data?.myCso?.edges[0]?.node?.csocollaborationneeds
        ?.collaborationNeeds?.edges ?? []
    );
    setSelectedStakeholder(
      collaborationNeeds?.data?.myCso?.edges[0]?.node?.csocollaborationneeds
        ?.stakeholders?.edges ?? []
    );
  }, [collaborationNeeds]);

  return (
    <div>
      <div>
        <MissionCard obj={obj} />
        <Card className="org_contentarea">
          <Row>
            <Col md="12">
              <div className="d-flex flex-column" style={{ gap: "16px" }}>
                <div className="d-flex flex-column" style={{ gap: "8px" }}>
                  <div className="org_subtitle_sec">
                    <p
                      className="mb-0 font-weight-bold"
                      style={{ fontSize: "14px" }}
                    >
                      連携を通じて創造したい価値
                    </p>
                    {editState ? (
                      <div style={{ display: "flex" }}>
                        <Button
                          className="ema__btn__update"
                          onClick={async () => {
                            try {
                              await updateCollaborationNeeds({
                                variables: {
                                  ...(selectedIssues.length > 0 && {
                                    activityFields: selectedIssues?.map(
                                      (x) => x?.node?.id
                                    ),
                                  }),
                                  ...(selectedCorporationCategoryNeeds.length >
                                    0 && {
                                    collaborationNeeds:
                                      selectedCorporationCategoryNeeds?.map(
                                        (x) => x?.node?.id
                                      ),
                                  }),
                                  ...(selectedStakeholder.length > 0 && {
                                    stakeholders: selectedStakeholder?.map(
                                      (x) => x?.node?.id
                                    ),
                                  }),
                                  ...(interestingCounries.length > 0 && {
                                    countries: interestingCounries?.map(
                                      (x) => x?.id
                                    ),
                                  }),
                                },
                              });
                            } catch (err) {
                              console.log(err);
                              alert("正しい入力形式で入力してください");
                            }
                          }}
                        >
                          <SyncIcon fontSize="17px" />
                          <span className="pl-2">更新</span>
                        </Button>
                        <Button
                          style={{ padding: "0.3rem 8px" }}
                          onClick={() => {
                            setEditState(false);
                            setInterestingCounries(
                              collaborationNeeds?.data?.myCso?.edges[0]?.node?.csocollaborationneeds?.countries?.edges?.map(
                                (country) => {
                                  return {
                                    id: country?.node?.id,
                                    nameJp: country?.node?.nameJp,
                                  };
                                }
                              )
                            );
                            setSelectedIssues(
                              collaborationNeeds?.data?.myCso?.edges[0]?.node
                                ?.csocollaborationneeds?.activityFields?.edges
                            );
                            setSelectedCorporationCategoryNeeds(
                              collaborationNeeds?.data?.myCso?.edges[0]?.node
                                ?.csocollaborationneeds?.collaborationNeeds
                                ?.edges
                            );
                            setSelectedStakeholder(
                              collaborationNeeds?.data?.myCso?.edges[0]?.node
                                ?.csocollaborationneeds?.stakeholders?.edges
                            );
                            // setInterestingCounries(orgSupporterMission?.data?.allSupporters?.edges[0]?.node?.interestingCountry?.edges?.map(branch => {
                            //     return {
                            //         id: branch?.node?.id,
                            //         nameJp: branch?.node?.nameJp,
                            //     }
                            // }))
                            // setSelectedIssues(orgSupporterMission?.data?.allSupporters?.edges[0]?.node?.interestingActivity?.edges)
                            // setSelectedCorporationCategoryNeeds(orgSupporterMission?.data?.allSupporters?.edges[0]?.node?.collaborationNeeds?.edges)
                            // setSelectedStakeholder(orgSupporterMission?.data?.allSupporters?.edges[0]?.node?.focusedStakeholders?.edges)
                          }}
                        >
                          <CloseIcon fontSize="16px" className="pointer" />
                        </Button>
                      </div>
                    ) : (
                      <>
                        {myPage && (
                          <Button
                            className="ema__btn__edit"
                            onClick={() => {
                              setEditState({
                                ...editState,
                                colaboration: true,
                              });
                            }}
                          >
                            <SettingIcon fontSize="20px" />
                            {/* Change Here */}
                            <span className="pl-2">情報の編集</span>
                          </Button>
                        )}
                      </>
                    )}
                  </div>
                  <Row>
                    <Col xs="12" md={2} className="mb-3">
                      <p
                        className="mb-0 font-weight-normal"
                        style={{
                          fontSize: "13px",
                          color: "#495057",
                          display: "flex",
                          alignItems: "center",
                          gap: "2px",
                        }}
                      >
                        地域
                        {/* Login Required */}
                        {myPage && (
                          <div className="ml-1 hatena_box">
                            <div className="hatena">
                              <span>？</span>
                            </div>
                            <div className="explaine">
                              <p>
                                本箇所と、[オーガニゼーション＞組織情報＞組織概要＞活動地域]は連動しています。
                              </p>
                              <p>
                                本箇所を入力することで上記箇所のデータが自動で反映されます。
                              </p>
                            </div>
                          </div>
                        )}
                      </p>
                    </Col>
                    <Col xs="12" md={10} className="mb-3">
                      {editState ? (
                        <Multiselect
                          dataKey="id"
                          textField="nameJp"
                          defaultValue={interestingCounries}
                          data={foreignBranchCountries?.data?.countries?.edges?.map(
                            (country) => {
                              return {
                                nameJp: country?.node?.nameJp,
                                id: country?.node?.id,
                              };
                            }
                          )}
                          onChange={(e) => {
                            setInterestingCounries(e);
                          }}
                        />
                      ) : (
                        <p
                          className="mb-0 font-weight-normal"
                          style={{ fontSize: "13px", color: "#000000" }}
                        >
                          {myPage && (
                            <>
                              {loading || collaborationNeeds.loading ? (
                                <Loader color="#44CAE1" />
                              ) : (
                                <>
                                  {interestingCounries?.map(
                                    (country, index) => {
                                      return (
                                        <span key={index}>
                                          {index === 0
                                            ? country?.nameJp
                                            : `, ${country?.nameJp}`}
                                        </span>
                                      );
                                    }
                                  )}
                                </>
                              )}
                            </>
                          )}
                          {!myPage && (
                            <>
                              {loading || collaborationNeeds.loading ? (
                                <Loader color="#44CAE1" />
                              ) : (
                                <>
                                  {obj?.csocollaborationneeds?.countries?.edges?.map(
                                    (country, index) => {
                                      return (
                                        <span key={index}>
                                          {index === 0
                                            ? country?.node?.nameJp
                                            : `, ${country?.node?.nameJp}`}
                                        </span>
                                      );
                                    }
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </p>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12" md={2} className="mb-3">
                      <p
                        className="mb-0 font-weight-normal"
                        style={{ fontSize: "13px", color: "#495057" }}
                      >
                        課題分野
                      </p>
                    </Col>
                    <Col xs="12" md={10} className="mb-3">
                      <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                        {loading || allActivity.loading ? (
                          <Loader color="#44CAE1" />
                        ) : (
                          <>
                            {allActivity?.data?.allActivityfields?.edges?.map(
                              (issue, index) => {
                                return (
                                  <div
                                    key={index}
                                    onClick={() => {
                                      if (!editState.colaboration) return;
                                      handleChangeIssue(issue);
                                    }}
                                    style={{
                                      padding: "6px 17px",
                                      borderRadius: "5px",
                                      backgroundColor: !myPage
                                        ? obj?.csocollaborationneeds?.activityFields?.edges?.find(
                                            (x) =>
                                              x?.node?.id === issue?.node?.id
                                          )
                                          ? "#44cae1"
                                          : "#c4c4c4"
                                        : collaborationNeeds?.data?.myCso?.edges[0]?.node?.csocollaborationneeds?.activityFields?.edges?.find(
                                            (x) =>
                                              x?.node?.id === issue?.node?.id
                                          ) &&
                                          selectedIssues?.find(
                                            (x) =>
                                              x?.node?.id === issue?.node?.id
                                          )
                                        ? "#44cae1"
                                        : selectedIssues?.find(
                                            (x) =>
                                              x?.node?.id === issue?.node?.id
                                          )
                                        ? "#44cae180"
                                        : collaborationNeeds?.data?.myCso?.edges[0]?.node?.csocollaborationneeds?.activityFields?.edges?.find(
                                            (x) =>
                                              x?.node?.id === issue?.node?.id
                                          )
                                        ? "#c4c4c480"
                                        : "#c4c4c4",
                                      color: "white",
                                      fontSize: "12px",
                                      fontWeight: 700,
                                      cursor: editState.colaboration
                                        ? "pointer"
                                        : "inherit",
                                    }}
                                  >
                                    <p className="m-0">{issue?.node?.name}</p>
                                  </div>
                                );
                              }
                            )}
                          </>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12" md={2} className="mb-3">
                      <p
                        className="mb-0 font-weight-normal"
                        style={{ fontSize: "13px", color: "#495057" }}
                      >
                        連携方法・ニーズ
                      </p>
                    </Col>
                    <Col xs="12" md={10} className="mb-3">
                      <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                        {loading || allFields.loading ? (
                          <Loader color="#44CAE1" />
                        ) : (
                          <>
                            {allFields?.data?.allCollaborationNeeds?.edges?.map(
                              (collaborationNeed, index) => {
                                return (
                                  <div
                                    key={index}
                                    onClick={() => {
                                      if (!editState) return;
                                      handleChangeNeed(collaborationNeed);
                                    }}
                                    style={{
                                      padding: "6px 17px",
                                      borderRadius: "5px",
                                      backgroundColor: !myPage
                                        ? obj?.csocollaborationneeds?.collaborationNeeds?.edges?.find(
                                            (x) =>
                                              x?.node?.id ===
                                              collaborationNeed?.node?.id
                                          )
                                          ? "#44cae1"
                                          : "#c4c4c4"
                                        : collaborationNeeds?.data?.myCso?.edges[0]?.node?.csocollaborationneeds?.collaborationNeeds?.edges?.find(
                                            (x) =>
                                              x?.node?.id ===
                                              collaborationNeed?.node?.id
                                          ) &&
                                          selectedCorporationCategoryNeeds?.find(
                                            (x) =>
                                              x?.node?.id ===
                                              collaborationNeed?.node?.id
                                          )
                                        ? "#44cae1"
                                        : selectedCorporationCategoryNeeds?.find(
                                            (x) =>
                                              x?.node?.id ===
                                              collaborationNeed?.node?.id
                                          )
                                        ? "#44cae180"
                                        : collaborationNeeds?.data?.myCso?.edges[0]?.node?.csocollaborationneeds?.collaborationNeeds?.edges?.find(
                                            (x) =>
                                              x?.node?.id ===
                                              collaborationNeed?.node?.id
                                          )
                                        ? "#c4c4c480"
                                        : "#c4c4c4",
                                      color: "white",
                                      fontSize: "12px",
                                      fontWeight: 700,
                                      cursor: editState ? "pointer" : "inherit",
                                    }}
                                  >
                                    <p className="m-0">
                                      {collaborationNeed?.node?.title}
                                    </p>
                                  </div>
                                );
                              }
                            )}
                          </>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12" md={2} className="mb-3">
                      <p
                        className="mb-0 font-weight-normal"
                        style={{ fontSize: "13px", color: "#495057" }}
                      >
                        ステークホルダー
                      </p>
                    </Col>
                    <Col xs="12" md={10} className="mb-3">
                      <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                        {loading || allFields.loading ? (
                          <Loader color="#44CAE1" />
                        ) : (
                          <>
                            {allFields?.data?.allTarget?.edges?.map(
                              (stakeholder, index) => {
                                return (
                                  <div
                                    key={index}
                                    onClick={() => {
                                      if (!editState.colaboration) return;
                                      handleChangeStakeholder(stakeholder);
                                    }}
                                    style={{
                                      padding: "6px 17px",
                                      borderRadius: "5px",
                                      backgroundColor: !myPage
                                        ? obj?.csocollaborationneeds?.stakeholders?.edges?.find(
                                            (x) =>
                                              x?.node?.id ===
                                              stakeholder?.node?.id
                                          )
                                          ? "#44cae1"
                                          : "#c4c4c4"
                                        : collaborationNeeds?.data?.myCso?.edges[0]?.node?.csocollaborationneeds?.stakeholders?.edges?.find(
                                            (x) =>
                                              x?.node?.id ===
                                              stakeholder?.node?.id
                                          ) &&
                                          selectedStakeholder?.find(
                                            (x) =>
                                              x?.node?.id ===
                                              stakeholder?.node?.id
                                          )
                                        ? "#44cae1"
                                        : selectedStakeholder?.find(
                                            (x) =>
                                              x?.node?.id ===
                                              stakeholder?.node?.id
                                          )
                                        ? "#44cae180"
                                        : collaborationNeeds?.data?.myCso?.edges[0]?.node?.csocollaborationneeds?.stakeholders?.edges?.find(
                                            (x) =>
                                              x?.node?.id ===
                                              stakeholder?.node?.id
                                          )
                                        ? "#c4c4c480"
                                        : "#c4c4c4",
                                      color: "white",
                                      fontSize: "12px",
                                      fontWeight: 700,
                                      cursor: editState.colaboration
                                        ? "pointer"
                                        : "inherit",
                                    }}
                                  >
                                    <p className="m-0">
                                      {stakeholder?.node?.name}
                                    </p>
                                  </div>
                                );
                              }
                            )}
                          </>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
};

export default SettingOrgTab2;
